class FormValidator {
   constructor(form, fields) {
      this.form = form;
      this.fields = fields;
   }

   initialize() {
      this.validateOnEntry();
      this.validateOnSubmit();
   }

   validateOnSubmit() {
      let self = this;

      const submitButtons = this.form.querySelectorAll('.wcl-js-submit-button');

      submitButtons.forEach(button => {
         button.addEventListener('click', e => {
            e.preventDefault();
            self.fields.forEach(field => {
               const input = document.querySelector(`#${field}`);
               self.validateFields(input);
            });
         });
      });
   }

   validateOnEntry() {
      let self = this;
      this.fields.forEach(field => {
         const input = document.querySelector(`#${field}`);

         if (input) {
            input.addEventListener('input', event => {
               self.validateFields(input);
            });
         }
      });
   }

   validateFields(field) {
      // Check presence of values
      if (field.value.trim() === "") {
         this.setStatus(field, multilanguage_object["This field is required."], "error");
      } else {
         this.setStatus(field, null, "success");
      }

      // Check for a valid email address
      if (field.type === "email") {
         const re = /\S+@\S+\.\S+/;
         if (re.test(field.value)) {
            this.setStatus(field, null, "success");
         } else if (field.value.trim() === "") {
            this.setStatus(field, multilanguage_object["This field is required."], "error");
         } else {
            this.setStatus(field, multilanguage_object["Invalid email address."], "error");
         }
      }

      // Password confirmation edge case
      if (field.id === "user_confirm_password" || field.id === "user_confirm_new_password") {
         let passwordField;

         if (field.id === "user_confirm_password") {
            passwordField = this.form.querySelector('#user_password');
         } else if (field.id === "user_confirm_new_password") {
            passwordField = this.form.querySelector('#user_set_new_password');
         }

         if (field.value.trim() === "") {
            this.setStatus(field, multilanguage_object["This field is required."], "error");
         } else if (field.value !== passwordField.value) {
            this.setStatus(field, multilanguage_object["Password does not match"], "error");
         } else {
            this.setStatus(field, null, "success");
         }
      }

      // Check password strength
      if (field.id === "user_password" || field.id === "user_set_new_password") {
         const currentForm = field.closest('.wcl-modal-form');
         const infoStrengthMessage = currentForm.querySelector('.wcl-password-info-message');
         const strengthMessage = currentForm.querySelector('.wcl-password-strength-message');

         if (field.value.trim().length >= 8) {
            strengthMessage.classList.remove('hidden');
            infoStrengthMessage.classList.add('hidden');
         } else {
            strengthMessage.classList.add('hidden');
            infoStrengthMessage.classList.remove('hidden');
         }
      }
   }

   setStatus(field, message, status) {
      const errorIcon = field.parentElement.querySelector('.wcl-icon-error');
      const errorMessage = field.parentElement.querySelector('.wcl-error-message');

      if (status === "success") {

         if (errorMessage) {
            errorMessage.innerText = "";
            errorMessage.classList.add('hidden');
            const wrapper = errorMessage.closest('.wcl-message-wrapper');
            if (wrapper) {
               wrapper.classList.remove('show');
            }
         }

         if (errorIcon) {
            errorIcon.classList.add('hidden');
         }

         field.classList.remove('wcl-input-error');
      }

      if (status === "error") {

         if (errorMessage) {
            errorMessage.innerText = message;
            errorMessage.classList.remove('hidden');
            errorMessage.closest('.wcl-message-wrapper').classList.add('show');
         }

         if (errorIcon) {
            errorIcon.classList.remove('hidden');
         }

         field.classList.add('wcl-input-error');
      }
   }
}

document.addEventListener('DOMContentLoaded', () => {
   const forms = document.querySelectorAll('.wcl-modal-form');

   forms.forEach(form => {
      let fields;
      if (form.classList.contains('wcl-modal-register-form')) {
         fields = ["user_first_name", "user_last_name", "user_email", "user_password", "user_confirm_password"];
      } else if (form.classList.contains('wcl-modal-login-form')) {
         fields = ["user_login_email", "user_login_password"];
      } else if (form.classList.contains('wcl-modal-forgot-password')) {
         fields = ["wcl_forgot_password_email"];
      } else if (form.classList.contains('wcl-modal-form-set-new-password')) {
         fields = ["user_set_new_password", "user_confirm_new_password"];
      } else {
         fields = [];
      }

      const validator = new FormValidator(form, fields);
      validator.initialize();
   });
});